import App from "./App-redux";

export default App;
